import React from 'react';
import {ShopifySubscription} from '../../interfaces';
import {DataGrid, GridColDef} from '@mui/x-data-grid';
import {Button, Paper} from '@mui/material';

interface Props {
  shopifySubscriptions: ShopifySubscription[];
  onCompleteReturn: (id: number) => void;
}

const ShopifySubscriptionPendingReturns: React.FC<Props> = ({
  shopifySubscriptions,
  onCompleteReturn,
}) => {
  const columns: GridColDef[] = [
    {
      field: 'id',
      headerName: 'ID',
      width: 90,
      filterable: true,
    },
    {
      field: 'email',
      headerName: 'Email',
      width: 300,
      filterable: true,
    },
    {
      field: 'quantity',
      headerName: 'Quantity',
      width: 120,
      filterable: true,
    },
    {
      field: 'returnOrderName',
      headerName: 'Return Order Name',
      width: 200,
      filterable: true,
    },
    {
      field: 'returnStatus',
      headerName: 'Return Status',
      width: 150,
      filterable: true,
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: 'Complete Return',
      width: 150,
      renderCell: val => {
        return (
          <Button onClick={() => onCompleteReturn(val.id as number)}>
            Complete Return
          </Button>
        );
      },
    },
  ];

  return (
    <Paper sx={{height: 700}}>
      <DataGrid rows={shopifySubscriptions ?? []} columns={columns} />
    </Paper>
  );
};

export default React.memo(ShopifySubscriptionPendingReturns);
